import React from 'react'

import { RenderZionCMSItems } from '../../utils/RenderZionCMSItem/RenderZionCMSItem'

type SharedSectionsContentProps = ZionCMSSharedSectionsContent

export default function SharedSectionsContent({ sections }: SharedSectionsContentProps): JSX.Element {
  if (!sections?.length) {
    return <></>
  }
  return <RenderZionCMSItems items={sections} />
}
